import {destroyAllSignals, json, MiniSignal} from "p3";
import common from "../../../common";

export default class Inventory {
    constructor() {
        this.signals = {
            add: new MiniSignal(),
            remove: new MiniSignal()
        };

        this._items = {};
    }

    destroy() {
        destroyAllSignals(this.signals);

        this.emptyItems();
    }

    /**
     * @param {string} id
     * @param {number} [count=1]
     * @return {number}
     */
    addItem(id, count = 1) {
        count = Math.max(0, count);

        const metadata = json("inventory").filter(x => x.id === id)[0];
        if (metadata) {
            if (metadata.unique && this.itemQuantity(id) > 0) {
                return 1;
            }
        }

        if (typeof this._items[id] === "undefined") {
            this._items[id] = 0;
        }
        this._items[id] += count;
        this.signals.add.dispatch(id, count, this._items[id]);

        this.saveToActiveSlot();

        return this._items[id];
    }

    /**
     * @param {string} id
     * @param {number} [count=1]
     * @return {number}
     */
    removeItem(id, count = 1) {
        count = Math.max(0, count);
        if (typeof this._items[id] !== "undefined") {
            this._items[id] = Math.max(0, this._items[id] - count);
        }
        this.signals.remove.dispatch(id, count, this._items[id]);

        this.saveToActiveSlot();

        return this.itemQuantity(id);
    }

    emptyItems() {
        this._items = {};
    }

    getAllItems() {
        let arr = [];
        for(let i in this._items){
            arr.push(this._items[i]);
        }
        return arr;
    }

    /**
     * @param {string} id
     * @return {number}
     */
    itemQuantity(id) {
        let count = this._items[id];
        return count > 0 ? count : 0;
    }

    /**
     * @param {string} id
     * @return {Boolean}
     */
    isAnInventoryItem(id) {
        const data = json("inventory").slice();
        for(let i in data) {
            ////console.log(data[i].id, id);
            if (data[i].id == id)
                return true;
        }
        return false;
    }

    saveToActiveSlot() {
        const activeSlot = common.saveData.activeSlot;

        for (const id in this._items) {
            if (this._items.hasOwnProperty(id)) {
                activeSlot.inventory[id] = this.itemQuantity(id);
            }
        }

        common.saveData.saveGame();
    }

    loadFromActiveSlot() {
        const activeSlot = common.saveData.activeSlot;

        let totalItems = 0;
        for (const id in activeSlot.inventory) {
            if (activeSlot.inventory.hasOwnProperty(id)) {
                const count = activeSlot.inventory[id];
                this.addItem(id, count);
                totalItems += count;
            }
        }
        ////console.log("[" + this.constructor.name + "]", "Loaded inventory - (total: " + totalItems + ")");
    }
}